import { Component } from 'react';
import cx from 'classnames';
import { bool, func, shape } from 'prop-types';
import { assignedStates } from '../../../utils/boxStates';
import { campaignState } from '../../../utils/campaignState';
import { scrollToComponent } from '../../../utils/scroll-to-component';
import { isSelectMember } from '../../../utils/user';
import PageNav from '../SharedComponents/PageNav/PageNav';
import ProductContainer from '../SharedComponents/ProductContainer/ProductContainer';
import RevealBox from './RevealBox';
import './ExplorePanel.css';

const surpriseItem = {
  title: 'Mystery Surprise',
  image:
    'https://static.fabfitfun.com/wp-content/uploads/2020/02/icon-surprise-me%402x_1582677417.6491_1582677417.9295.jpg',
};

class ExplorePanel extends Component {
  state = {
    currentPage: 1,
    pageLength: 5,
  };

  getTotalValue = (boxData) => {
    let total = 0;
    let hasMysteryItem = false;

    const { customizations } = boxData;

    customizations.forEach((customization) => {
      if (!customization.choice) {
        return false;
      }
      if (customization.additionalItems.length) {
        customization.additionalItems.forEach((item) => {
          total += item.additionalQuantity * item.retailPrice;
          if (item.title === 'FFF Picks - 1 Per Box') {
            hasMysteryItem = true;
          }
        });
      }
      const { choice } = customization;
      if (choice.title === 'FFF Picks - 1 Per Box') {
        hasMysteryItem = true;
      }
      total +=
        choice.additionalQuantity * choice.retailPrice +
        choice.primaryQuantity * choice.retailPrice;
    });

    if (hasMysteryItem) {
      return `$${(210.95 + total).toFixed(2)}-$${(370.5 + total).toFixed(2)}`;
    }

    return `$${total.toFixed(2)}`;
  };

  getOpenStatus = (boxData) => {
    if (boxData && boxData.season) {
      const now = Date.now();
      if (now < new Date(boxData.season.addOnsEndDate)) {
        return campaignState.OPEN;
      }
    }
    return campaignState.CLOSED;
  };

  getItems = (boxData) => {
    let items = [];
    if (!boxData) {
      return items;
    }

    if (boxData.customizations) {
      const additionalChoices = boxData.customizations.reduce(
        (acc, cust) => (cust.additionalItems !== null ? [...acc, ...cust.additionalItems] : acc),
        [],
      );
      const regularChoices = boxData.customizations.reduce((acc, cust) => {
        const { currentBox } = boxData;
        if (cust.choice && cust.choice.autoAssigned && currentBox && !currentBox.boxRevealed) {
          return [...acc, { ...cust.choice, ...surpriseItem }];
        }
        return cust.choice !== null ? [...acc, cust.choice] : acc;
      }, []);
      items = items.concat(
        [...regularChoices, ...additionalChoices].map((cust) => ({
          ...cust,
          name: cust.title,
          productId: cust.id,
          url: cust.image,
        })),
      );
    }

    return items;
  };

  getPageItems = (boxData) => {
    const items = this.getItems(boxData);
    const { currentPage, pageLength } = this.state;

    if (!items || !items.length) {
      return [];
    }

    const start = (currentPage - 1) * pageLength;
    const end = start + pageLength;

    return items.slice(start, end);
  };

  render() {
    const { boxData = {}, sysdata = {} } = this.props;
    const { pageLength } = this.state;
    const { isMobile, userData, saveRevealState, revealCallback } = sysdata;
    const { currentBox = {} } = boxData;
    const status = this.getOpenStatus(boxData);
    const totalValue = this.getTotalValue(boxData);
    const items = this.getItems(boxData);
    const pageItems = this.getPageItems(boxData);
    const isSelect = isSelectMember(userData);
    const showRevealBox =
      currentBox && !currentBox.boxRevealed && items.some((item) => item.autoAssigned);
    const boxSku = currentBox ? currentBox.sku : '0';
    const currentBoxName = currentBox ? currentBox.name : '';

    const statusContainerStyle = cx({
      'd-flex': isMobile,
      'flex-jsa': isMobile,
    });

    const totalValueStyle = cx({
      'mar-h-4': true,
      'c-black-60': true,
      'ff-ns': true,
      'd-flex': true,
      'flex-aic': true,
    });

    const titleStyle = cx({
      'mar-0': true,
      'ta-center': isMobile,
      'ff-pds': true,
      'fs-36': true,
      'fw-normal': true,
      'add-ons-view-title': true,
    });

    const containerStyle = cx({
      'd-flex': true,
      'flex-jsb': true,
      'flex-fdc': isMobile,
      'flex-aic': isMobile,
    });

    const productGridWrapperStyle = cx({
      'w-60': !isMobile && showRevealBox,
    });

    return (
      <div className="explore-panel">
        <div className="mar-h-16">
          <h1
            ref={(section) => {
              this.Header = section;
            }}
            className={titleStyle}
          >
            Explore your{' '}
            {currentBoxName.toLowerCase().includes('box')
              ? currentBoxName
              : `${currentBoxName} Box`}
          </h1>
          {!showRevealBox && (
            <div className={statusContainerStyle}>
              <div className={totalValueStyle}>Total Value: {`${totalValue}`}</div>
            </div>
          )}
        </div>

        {/* User has items */}
        {/* {!!items.length && ( */}
        <div className={containerStyle}>
          {isMobile && items.length > pageLength && (
            <PageNav
              maxPageCount={4}
              currentPage={this.state.currentPage}
              totalPages={Math.ceil(items.length / pageLength)}
              onChange={(pg) => {
                this.setState({ currentPage: pg });
                scrollToComponent(this.Header, {
                  offset: 0,
                  align: 'top',
                  duration: 500,
                });
              }}
            />
          )}
          {!!items.length && (
            <div className={productGridWrapperStyle}>
              <ProductContainer
                products={isMobile ? pageItems : items}
                exploreDisplay
                open={status === campaignState.OPEN}
                viewAll
                isMobile={isMobile}
                hasBeenAssigned={assignedStates.includes(boxData.currentBox.boxStatus)}
                isSelect={isSelect}
              />
            </div>
          )}
          {showRevealBox && (
            <RevealBox
              currentBoxName={currentBoxName}
              isMobile={isMobile}
              saveRevealState={saveRevealState}
              revealCallback={revealCallback}
              boxSku={boxSku}
            />
          )}
        </div>

        <br />
        {isMobile && items.length > pageLength && (
          <PageNav
            maxPageCount={4}
            currentPage={this.state.currentPage}
            totalPages={Math.ceil(items.length / pageLength)}
            onChange={(pg) => {
              this.setState({ currentPage: pg });
              scrollToComponent(this.Header, {
                offset: 0,
                align: 'top',
                duration: 500,
              });
            }}
          />
        )}

        <div className="hor-rule" />
      </div>
    );
  }
}
ExplorePanel.propTypes = {
  sysdata: shape({
    saveRevealState: func.isRequired,
    revealCallback: func.isRequired,
  }).isRequired,
  boxData: shape({
    currentBox: shape({
      boxRevealed: bool,
    }),
  }),
};

ExplorePanel.defaultProps = {
  boxData: {
    currentBox: {},
  },
};

export default ExplorePanel;
